module.exports = __webpack_public_path__ + "static/media/IMG_021.5e16a6ea.JPG";